import { render } from "./swift-templates.vue?vue&type=template&id=0cad526e&scoped=true&ts=true"
import script from "./swift-templates.vue?vue&type=script&lang=ts"
export * from "./swift-templates.vue?vue&type=script&lang=ts"

import "./swift-templates.vue?vue&type=style&index=0&id=0cad526e&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cad526e"]])

export default __exports__